import { Transition, TransitionChild } from '@headlessui/react';

import type {
    FBPostTypesType,
    IGPostTypesType,
    IGStoryTypesType,
    LIPostTypesType,
    PIPostTypesType,
    TIPostTypesType,
    TWPostTypesType,
    YTPostTypesType
} from '@/lib/posts/postTypes';

import Post from '@/components/base/Post';

type AlbumPostIconProps = {
    show: boolean;
    type:
        | IGPostTypesType
        | IGStoryTypesType
        | TIPostTypesType
        | FBPostTypesType
        | TWPostTypesType
        | LIPostTypesType
        | YTPostTypesType
        | PIPostTypesType;
};

export function AlbumPostIcon({ show, type }: AlbumPostIconProps) {
    return (
        <span className="absolute bottom-6 left-6 z-1">
            <Transition show={show}>
                <TransitionChild
                    enter="transition ease-in-out duration-75 transform"
                    enterFrom="-translate-x-full opacity-0"
                    enterTo="translate-x-0 opacity-100"
                    leave="transition ease-in-out duration-75 transform"
                    leaveFrom="translate-x-0 opacity-100"
                    leaveTo="-translate-x-full opacity-0">
                    <div className="flex items-center justify-center">
                        <Post.PostTypeIcon type={type} className="bottom-[-1.25rem] left-[-1.25rem]" />
                    </div>
                </TransitionChild>
            </Transition>
        </span>
    );
}
